<template>
  <li class="order-item">
    <article>
      <!-- Order header -->
      <OrderItemHeader :item="order" />

      <!-- Order Items -->
      <section class="order-item-body">
        <!--displayed photos-->
        <article class="order-previews-container">
          <template
            v-for="item in photosToDisplay"
            :key="item"
          >
            <template v-if="order.status !== 'Awaiting Payment' && item.thumbnail?.url">
              <div class="relative w-max h-30 md:h-40 md:max-w-56">
                <template v-if="item.type === PhotoType.Single">
                  <img
                    :src="item.thumbnail.url"
                    alt="Photo in your order"
                    class="h-full"
                  >
                </template>

                <template v-else>
                  <img
                    v-for="i in 3"
                    :key="i"
                    alt="Photo in your order"
                    :src="item.thumbnail.url"
                    class="first:top-0 first:left-0 [&:nth-child(2)]:top-2 [&:nth-child(2)]:absolute [&:nth-child(2)]:left-2 last:absolute last:top-4 last:left-4 h-11/12 pr-4"
                  >
                </template>
              </div>
            </template>

            <template v-else>
              <div class="relative w-max">
                <template v-if="item.type === PhotoType.Single">
                  <PhotoThumbnailPlaceholder />
                </template>

                <template v-else>
                  <PhotoThumbnailPlaceholder
                    v-for="i in 3"
                    :key="i"
                    class="first:top-0 first:left-0 [&:nth-child(2)]:top-2 [&:nth-child(2)]:absolute [&:nth-child(2)]:left-2 last:absolute last:top-4 last:left-4 h-11/12 pr-4 -ml-2 mr-2 -mt-3 scale-[90%]"
                  />
                </template>
              </div>
            </template>
          </template>
        </article>

        <span
          v-if="additionalPhotos > 0"
          class="font-medium text-primary whitespace-nowrap"
        >
          +{{ additionalPhotos }} more
        </span>
      </section>
    </article>
  </li>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';

import OrderItemHeader from '@/components/orders/OrderItemHeader.vue';
import { PhotoThumbnailPlaceholder } from '@/components/placeholders';
import { PhotoType } from '@/const.js';

const props = defineProps({
  order: Object,
});

const viewportWidth = ref(window.innerWidth);

const isSmallViewport = computed(() => {
  return viewportWidth.value < 768; // Tailwind's `md` breakpoint is 768px
});

const handleResize = () => {
  viewportWidth.value = window.innerWidth;
};

onMounted(() => {
  window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
});

const getIsPortrait = (item) => {
  return item.thumbnail?.dimensions.height > item?.thumbnail?.dimensions.width;
};

const landscapeCount = computed(() => {
  return props.order.items.slice(0, 3).filter(item => !getIsPortrait(item)).length;
});

// based on screen size and then how many landscapes present in first 3
const photosToDisplay = computed(() => {
  return isSmallViewport.value ? props.order.items.slice(0, 1) :
    (props.order.status !== 'Awaiting Payment' && landscapeCount.value >= 2 ? props.order.items.slice(0, 2) : props.order.items.slice(0, 3));
});

// +n more
const additionalPhotos = computed(() => {
  return props.order.items.length - (isSmallViewport.value ? 1 : (props.order.status !== 'Awaiting Payment' && landscapeCount.value >= 2 ? 2 : 3));
});

</script>
